import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useFamilyStore } from '@/store/familyStore';
import { AddChildForm } from '../components/add-child/AddChildForm';
import { InvalidLink, SubmissionSuccess, SharedLayout } from '../components';
import { useSharedLink } from '../hooks/useSharedLink';
import { generateId } from '@/utils/generators';
import { AddRequest } from '@/types';

export function SharedAdd() {
  const { token } = useParams();
  const { addRequest, members } = useFamilyStore();
  const { link, error, isValid } = useSharedLink(token, 'add');
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  const parent = link?.targetId ? members.find(m => m.id === link.targetId) : null;
  
  const [formData, setFormData] = useState({
    requesterId: generateId(),
    requesterName: parent?.name || '',
    phoneNumber: '',
    childName: '',
    parentId: link?.targetId || '',
  });

  if (!isValid || !link?.targetId) {
    return <InvalidLink message={error || 'رابط غير صالح'} />;
  }

  if (isSubmitted) {
    return <SubmissionSuccess type="add" />;
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const request = {
      id: generateId(),
      requesterId: formData.parentId, // Use selected parent ID
      requesterName: members.find(m => m.id === formData.parentId)?.name || '', // Get parent name
      phoneNumber: formData.phoneNumber, // Use entered phone number
      childName: formData.childName,
      parentId: formData.parentId,
      status: 'pending' as const,
      timestamp: Date.now(),
      linkId: link.id
    };


    console.log({request});
    
    addRequest(request);
    setIsSubmitted(true);
  };

  return (
    <SharedLayout title="طلب إضافة مولود">
      <AddChildForm
        formData={formData}
        onChange={setFormData}
        onSubmit={handleSubmit}
        initialParentId={link.targetId}
      />
    </SharedLayout>
  );
}


